const key = "SUBMENU"

export const SUBMENU = {
        OPEN: `${key}_OPEN`,
        CLEAR: `${key}_CLEAR`,
};